export const chartDays = [
  {
    label: "24/H",
    value: 1,
  },
  {
    label: "1/M",
    value: 30,
  },
  {
    label: "3/M",
    value: 90,
  },
  {
    label: "Year",
    value: 365,
  },
];
